<script setup>
import { RouterLink, useRouter } from 'vue-router';
import { useRequestsStore } from '@/stores/storeRequests';
import { useQuizMatchesStore } from '@/stores/storeQuizMatches';
import { useGameHistory } from "@/composables/useGameHistory";
import { sendMetrik } from '@/utils/metrika';
import ProfileGameSessionTimer from '@/components/profile/ProfileGameSessionTimer.vue';
import ProfileGameBanner from '@/components/profile/ProfileGameBanner.vue';

const storeRequests = useRequestsStore();
const storeQuizMatches = useQuizMatchesStore();
const { remainingTime } = useGameHistory();
const router = useRouter();
const goToGameMatches = () => {
    if (storeQuizMatches.isMatchGameAvailable) {
        router.push('/quiz_matches/');
    }
}
// game_3_in_a_row_lk
</script>
<template>
    <ProfileGameBanner goal="game_3_in_a_row_lk" :active-link="!storeQuizMatches.isShowTimer" linkUrl="/quiz_matches/">
        <template #header>
            <RouterLink v-if="storeQuizMatches.isMatchGameAvailable" to="/quiz_matches/" @click="sendMetrik('reachGoal', 'game_3_in_a_row_lk')" class="game-banner__link">
                <svg width='24' height='24'><use href='#next'></use></svg>
            </RouterLink>
            <div @click="goToGameMatches" :class="['game-banner__img', {'active-link': storeQuizMatches.isMatchGameAvailable}]">
                <img class='full-img' width='200' height='120' src='@/assets/img/img_banner_match.webp' alt='изображение'>
            </div>
        </template>
        <template #title>Игра «3 в ряд»</template>
        <template #desc>Сыграйте и получите подарок после загрузки чека</template>
        <!-- <template #sessionTimer1 v-if="false">
            <ProfileGameSessionTimer :link="true" linkUrl="/quiz_matches/">
                <span class="game-banner__timer-text">Серия сбросится через:</span>
            </ProfileGameSessionTimer>
        </template> -->
        <template #sessionTimer2 v-if="storeQuizMatches.isShowTimer">
            <ProfileGameSessionTimer 
                :link="!storeQuizMatches.isShowTimer" 
                linkUrl="/quiz_matches/"
                :time="remainingTime" 
                goal="upload_check_3_in_a_row_lk"
                >
                <span class="session-timer__fire">🔥</span>
                <span class="game-banner__timer-text">Подарок сгорит через:</span>
            </ProfileGameSessionTimer>
        </template>
    </ProfileGameBanner>
</template>
<style lang='scss' scoped>
@use '@/assets/scss/base/vars';

</style>